"use strict";

exports.__esModule = true;
exports.openWindow = exports.objectToGetParams = exports.noop = exports.getLocation = void 0;

var noop = function noop() {
  return undefined;
};

exports.noop = noop;

var getLocation = function getLocation() {
  return typeof window !== 'undefined' && window.location ? window.location.href : '';
};

exports.getLocation = getLocation;

var objectToGetParams = function objectToGetParams(object, separator) {
  if (separator === void 0) {
    separator = '&';
  }

  var isEmpty = function isEmpty(value) {
    return typeof value === 'undefined' || value === '';
  };

  return Object.entries(object).map(function (_ref) {
    var key = _ref[0],
        value = _ref[1];
    return !isEmpty(value) && key + "=" + encodeURIComponent(value);
  }).filter(Boolean).join(separator);
};

exports.objectToGetParams = objectToGetParams;

var openWindow = function openWindow(url) {
  var windowWidth = 450;
  var windowHeight = 400;
  var left = typeof window !== 'undefined' && window.innerWidth / 2 - windowWidth / 2;
  var top = typeof window !== 'undefined' && window.innerHeight / 2 - windowHeight / 2;
  var config = objectToGetParams({
    height: windowHeight,
    width: windowWidth,
    location: 'no',
    toolbar: 'no',
    status: 'no',
    directories: 'no',
    menubar: 'no',
    scrollbars: 'yes',
    resizable: 'no',
    centerscreen: 'yes',
    chrome: 'yes',
    left: left,
    top: top
  }, ',');
  window.open(url, '', config);
};

exports.openWindow = openWindow;